
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Product, ThingGroupsApi, Transceiver, TransceiversApi } from '@/api';
import InformationRow from '@/components/display/information-row.vue';
import { ProductOrdwayAttributes } from '@/models/ordway';
import BillingSetupButton from '@/components/billing-setup-form/billing-setup-button.vue';
import InlineEditor from '@/components/display/inline-editor.vue';
import Toast from '@/components/display/toast.vue';
import { ApiUtils } from '@/common/ApiUtils';

@Component({
	components: { InlineEditor, InformationRow },
})
export default class ThingGroupRow extends Vue {
	@Prop({ required: true })
	private transceiver!: Transceiver;

	private selectedThingGroupName?: string | null = this.transceiver.thingGroupName;
	private thingGroupsList: any[] = [];

	private readonly thingGroupsApi = new ThingGroupsApi();
	private readonly transceiversApi = new TransceiversApi();
	private readonly toast = new Toast();

	public async created() {
		try {
			const response = await this.thingGroupsApi.getThingGroups({
				params: {
					include: 'transceivers,transceivers.site',
					perPage: 250,
				},
			});
			const data = response.data?.data ?? [];
			const thingGroups = data.sort((a: any, b: any) => (a.name > b.name ? 1 : -1));

			const groups: any[] = [];
			thingGroups.forEach(group => {
				groups.push(group.name);
			});
			this.thingGroupsList = groups;
		} catch (e) {
			console.log(e);
		}
	}

	private async saveThingGroup(callback: (hasError: boolean) => void) {
		try {
			await this.transceiversApi.updateTransceiver(this.transceiver.id!, {
				data: {
					serialNumber: this.transceiver.serialNumber,
					uniqueId: this.transceiver.uniqueId,
					imei: this.transceiver.imei,
					type: this.transceiver.type,
					thingId: this.transceiver.thingId,
					principalId: this.transceiver.principalId,
					status: this.transceiver.status,
					batchNumber: this.transceiver.batchNumber,
					bridge: this.transceiver.bridge,
					thingGroupName: this.selectedThingGroupName ?? this.transceiver.thingGroupName,
				},
			});
			this.toast.makeToast(
				'Updated transceiver thing group',
				'Success Updating Thing Group',
				'success',
			);
			this.transceiver.thingGroupName =
				this.selectedThingGroupName ?? this.transceiver.thingGroupName;
			callback(false);
		} catch (ex) {
			const { errorMessage } = ApiUtils.handleApiError(
				ex,
				'Error updating transceiver thing group',
			);
			this.toast.makeToast(errorMessage, 'Error Updating Thing Group', 'danger');
			callback(true);
		}
	}
}
